/* eslint-disable */
/**
 * Creates an injectable function that will create the approriately shapes `ActionError`
 * @param {Store} store The state management `store`
 * @returns {FromError} The `dispatch` aware injectable
 */
const createFromError = ({ dispatch }) => (error, meta, FROM_ERROR) => {
  return dispatch({
    complete: true,
    error,
    meta,
    payload: null,
    type: FROM_ERROR,
  });
};

export default createFromError;
